export enum Technology {
  ASSEMBLY = 'ASSEMBLY',
  CUTTING = 'CUTTING',
  EXTRUSION = 'EXTRUSION',
  INJECTIONMLD = 'INJECTIONMLD',
  IRONING = 'IRONING',
  KNIT = 'KNIT',
  REWIND = 'REWIND',
  STEAMFRM = 'STEAMFRM',
  THERMOFRM = 'THERMOFRM',
}
